import React from 'react';
import { Link } from 'react-router-dom';
import BoardMemberList from './BoardMemberList';

const BoardMember = () => {

    let sanjana = './images/board/sanjana.jpg';
    let induja = './images/board/induja.jpg';
    let kusal = './images/board/kusal.jpg';
    let nathasha = './images/board/nathasha.jpg';
    let oshuni = './images/board/oshuni.jpg';
    let nipuna = './images/board/nipuna.jpg';
    let uchith = './images/board/uchith.jpg';

    let vishmi = './images/board/vishmi.jpg';
    let ashen = './images/board/ashen.jpg';
    let chathura = './images/board/chathura.jpg';
    let ishini = './images/board/ishini.png';
    let thisuri = './images/board/thisuri.jpg';
    let sasith = './images/board/sasith.png';
    let vimukthi = './images/board/vimukthi.jpg';
    let erandi = './images/board/erandi.jpg';

    return (

        <div className="board-member-page">


            <div className="all-team-heading">
                <h2>Introducing <span> Office Bearers</span></h2>
            </div>
            <div className="member-grid-container">
                <div>
                    <div className="member-grid-item"><BoardMemberList
                        name="Leo Sanjana Ganegoda"
                        position="President"
                        imgUri={sanjana}
                        facebook='https://www.facebook.com/sanjana.sithira/'
                        linkedin='https://www.linkedin.com/in/sanjanaganegoda/'
                        instagram='https://instagram.com/sanjana.sithira?utm_medium=copy_link'

                    /></div>
                </div>

                <div>
                    <div className="member-grid-item"><BoardMemberList
                        name="Leo Induja Gunathilake"
                        position="1st Vice President"
                        imgUri={induja}
                        facebook='https://www.facebook.com/induja.gunathilake.7'
                        linkedin='http://localhost:3000/ourteam'
                        instagram='http://localhost:3000/ourteam'
                    /></div>
                </div>

                <div>
                    <div className="member-grid-item"><BoardMemberList
                        name="Leo Kusal Siriwardena"
                        position="2nd Vice President"
                        imgUri={kusal}
                        facebook='https://www.facebook.com/lahiru.rokes'
                        linkedin='https://www.linkedin.com/in/kusal-siriwardena-6683a51b4'
                        instagram='https://instagram.com/kusal_98?utm_medium=copy_link'
                    /></div>
                </div>

                <div>
                    <div className="member-grid-item"><BoardMemberList
                        name="Leo Nathasha Sandavinee"
                        position="Secretary"
                        imgUri={nathasha}
                        linkedin='https://www.linkedin.com/in/hasini-c-a04b2a172?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BPIeqHwBRRcSAvMvlz7ppew%3D%3D'
                        facebook='http://localhost:3000/ourteam'
                        instagram='https://instagram.com/sugar_cube1108?utm_medium=copy_link'
                    /></div>
                </div>

                <div>
                    <div className="member-grid-item"><BoardMemberList
                        name="Leo Oshuni Rajapaksha"
                        position="Assistant Secretary"
                        imgUri={oshuni}
                        facebook='https://www.facebook.com/dileeshakaveeshi.perera'
                        linkedin='http://localhost:3000/ourteam'
                        instagram='https://www.instagram.com/blossom_girla__00?r=nametag'
                    /></div>
                </div>

                <div>
                    <div className="member-grid-item"><BoardMemberList
                        name="Leo Nipuna Milan Kodithuwakku"
                        position="Treasurer"
                        imgUri={nipuna}
                        facebook='https://www.facebook.com/nipuna.milan.7'
                        linkedin='http://localhost:3000/ourteam'
                        instagram='https://instagram.com/nipunamilan?utm_medium=copy_link'
                    /></div>
                </div>

                <div>
                    <div className="member-grid-item"><BoardMemberList
                        name="Leo Uchith Nirosha Perera"
                        position="Assistant Treasurer"
                        imgUri={uchith}
                        facebook='https://www.facebook.com/uchith.perera'
                        linkedin='http://localhost:3000/ourteam'
                        instagram='https://instagram.com/uchith.niro?utm_medium=copy_link'
                    /></div>
                </div>

                <div>
                    <div className="member-grid-item"><BoardMemberList
                        name="Leo Vishmi Wanigasooriya"
                        position="Director - Member Relations"
                        imgUri={vishmi}
                        facebook='https://www.facebook.com/vishmi.wanigasooriya'
                        linkedin='https://www.linkedin.com/in/vishmi-wanigasooriya-86bba81a0'
                        instagram='https://instagram.com/_.vishmii._?utm_medium=copy_link'
                    /></div>
                </div>

                <div>
                    <div className="member-grid-item"><BoardMemberList
                        name="Leo Ashen Gnathilake"
                        position="Director - Community Service"
                        imgUri={ashen}
                        facebook='https://www.facebook.com/thisuri.dihara'
                        linkedin='http://localhost:3000/ourteam'
                        instagram='https://www.instagram.com/thisuri98/'
                    /></div>
                </div>

                <div>
                    <div className="member-grid-item"><BoardMemberList
                        name="Leo Chathura Bandara"
                        position="Director - Professional Development"
                        imgUri={chathura}
                        facebook='https://www.facebook.com/thisuri.dihara'
                        linkedin='http://localhost:3000/ourteam'
                        instagram='https://www.instagram.com/thisuri98/'
                    /></div>
                </div>

                <div>
                    <div className="member-grid-item"><BoardMemberList
                        name="Leo Ishini Doluweera"
                        position="Director - Public Relationships"
                        imgUri={ishini}
                        facebook='https://www.facebook.com/thisuri.dihara'
                        linkedin='http://localhost:3000/ourteam'
                        instagram='https://www.instagram.com/thisuri98/'
                    /></div>
                </div>

                <div>
                    <div className="member-grid-item"><BoardMemberList
                        name="Leo Thisuri Dihara Peiris"
                        position="Director - Environmental Services"
                        imgUri={thisuri}
                        facebook='https://www.facebook.com/thisuri.dihara'
                        linkedin='http://localhost:3000/ourteam'
                        instagram='https://www.instagram.com/thisuri98/'
                    /></div>
                </div>

                <div>
                    <div className="member-grid-item"><BoardMemberList
                        name="Leo Sasith Devinda"
                        position="Director - Fund Raising"
                        imgUri={sasith}
                        facebook='https://www.facebook.com/thisuri.dihara'
                        linkedin='http://localhost:3000/ourteam'
                        instagram='https://www.instagram.com/thisuri98/'
                    /></div>
                </div>

                <div>
                    <div className="member-grid-item"><BoardMemberList
                        name="Leo Vimukthi Wanduraba"
                        position="Director - Project Coordinating"
                        imgUri={vimukthi}
                        facebook='https://www.facebook.com/profile.php?id=100002866318170'
                        linkedin='https://www.linkedin.com/in/manjari-mihirangika-a4a0671ab'
                        instagram='https://www.instagram.com/invites/contact/?i=1nh8z99kx36k9&utm_content=1nrx7o8'
                    /></div>
                </div>

                <div>
                    <div className="member-grid-item"><BoardMemberList
                        name="Leo Erandi Manorathna"
                        position="Director - Editorial"
                        imgUri={erandi}
                        facebook='https://www.facebook.com/piyumigayath'
                        linkedin='http://localhost:3000/ourteam'
                        instagram='http://localhost:3000/ourteam'
                    /></div>
                </div>

            </div>


        </div>
    );
};

export default BoardMember;
